import type {MaterialMapsExporterCore} from "@cm/material-maps-exporter"
import {getDefaultPbrExportOptions} from "@common/helpers/material-maps-exporter"
import {MaterialOutputType} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export type PbrExportOption = {
    format: MaterialMapsExporterCore.Types.Format
    resolution: MaterialMapsExporterCore.Types.Resolution
}

// Derived, not restated: the exporter package owns which five types exist, what each converts to and
// how it reads, so this map cannot drift from the requests the same table builds.
export const PbrExportOptionLabels = new Map<MaterialOutputType, StateLabel<PbrExportOption>>(
    getDefaultPbrExportOptions().map(({materialOutputType, displayName, format, resolution}) => [
        materialOutputType,
        {label: displayName, state: {format, resolution}},
    ]),
)
